import React from 'react';

import { PageContentContainer } from '@/components/layout/PageContentContainer';

import styles from './ContactSupportPage.module.scss';

export const ContactSupportPage = () => (
  <PageContentContainer
    breadcrumbs={[{ title: 'Customer Support', current: true }]}
    className={styles.container}
  >
    <div className={styles.title}>
      <span>We were unable to find a valid company for your account.</span>
      <span>Please contact your project coordinator!</span>
    </div>
  </PageContentContainer>
);
